module.exports = __webpack_public_path__ + "static/img/anxunu05.0635733d.svg";